module.exports = __webpack_public_path__ + "static/media/ruflag.7a8b3a7d.svg";